export function LoadingDots({ text }: Readonly<{ text?: string }>) {
  return (
    <div className="flex items-center gap-2 text-(--color-text-secondary)">
      {text && <span className="text-sm">{text}</span>}
      <span className="dot-animation flex gap-1">
        <span className="w-2 h-2 rounded-full bg-(--color-accent) inline-block" />
        <span className="w-2 h-2 rounded-full bg-(--color-accent) inline-block" />
        <span className="w-2 h-2 rounded-full bg-(--color-accent) inline-block" />
      </span>
    </div>
  );
}
